import React, { useState } from 'react';
import './Registration.less';
import { Input, Button } from 'antd';
import { RightOutlined } from '@ant-design/icons';
import { useHistory, useParams } from 'react-router-dom';
import moment from 'moment';

import { usePackagingFlow } from '../../../context/PackagingFlowContext';
import {
    LoadingSession,
    LoadingSessionStatus,
    PackagingFlowDirection,
    PackagingFlowItem,
} from '../../../queries/api/types';
import { fetchLoadingSessions } from '../../../queries/api/loading-sessions';
import { fetchPackagingFlowByLoadingSession } from '../../../queries/api/packaging-flow';

const Registration: React.FC = () => {
    const [immatriculation, setImmatriculation] = useState('');
    const [showSessions, setShowSessions] = useState(false);
    const [filteredSessions, setFilteredSessions] = useState<LoadingSession[]>([]);
    const { setLoadingSession, setPackageFlow, setSelectedStore } = usePackagingFlow();
    const history = useHistory();
    const { storeId } = useParams<{ storeId: string }>();
    const handleImmatriculationChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setImmatriculation(e.target.value);
    };

    const handleSubmit = async () => {
        if (immatriculation) {
            try {
                const loadingSessions = await fetchLoadingSessions(
                    storeId,
                    LoadingSessionStatus.Completed,
                    immatriculation
                );
                setFilteredSessions(loadingSessions);
                setShowSessions(true);
            } catch (error) {
                console.error('Error fetching loading sessions:', error);
                setFilteredSessions([]);
                setShowSessions(false);
            }
        } else {
            setFilteredSessions([]);
            setShowSessions(false);
        }
    };

    const handleSessionSelect = async (session: LoadingSession) => {
        const response = await fetchPackagingFlowByLoadingSession(session.id);
        response.flowType = PackagingFlowDirection.RecivedInStore;
        setSelectedStore(response.recipient);

        if (response) {
            const updatedResponse = {
                ...response,
                packages: response.packages.map((pkg: PackagingFlowItem) => ({
                    ...pkg,
                    goodCount: pkg.goodCount === 0 && pkg.badCount === 0 ? pkg.shippedQuantity : pkg.goodCount,
                })),
            };
            setPackageFlow(updatedResponse);
            history.push(`/recipientMovement/${storeId}`);
        }
        setLoadingSession(session);
    };

    return (
        <div className="registration-page">
            <div className="title">
                <h2>Veuillez saisir les informations de la livraison</h2>
            </div>

            <label className="field-label" htmlFor="immatriculation-input">
                Immatriculation
            </label>
            <Input
                id="immatriculation-input"
                placeholder="Saisir l'immatriculation"
                value={immatriculation}
                onChange={handleImmatriculationChange}
                className="input-field"
            />
            <div className="submit-button">
                <Button type="primary" className="next-button" onClick={handleSubmit}>
                    Suivant
                </Button>
            </div>
            {showSessions && (
                <>
                    <div className="session-label">Selection de la livraison</div>
                    {filteredSessions.map((session, index) => (
                        <div key={index} className="session-box">
                            <h1>{session.warehouse.name}</h1>
                            <p>Remorque: {session.trailerNumber}</p>
                            <p>
                                Transporteur: {session.transporter.name}{' '}
                                <RightOutlined
                                    className="right-icon"
                                    onClick={async () => await handleSessionSelect(session)}
                                />
                            </p>
                            <div className="session-date-time">
                                {moment(session?.createdAt).format('DD/MM/YYYY')} -{' '}
                                {moment(session?.createdAt).format(' HH:mm')}
                            </div>
                        </div>
                    ))}
                </>
            )}
        </div>
    );
};

export default Registration;
